/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Bluefin/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Ach from './Ach/index'
import Card from './Card/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Bluefin({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentMethodValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'method',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentMethodValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ach'}>
<Ach
  viewPath={`${viewPath}/Ach`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Card'}>
<Card
  viewPath={`${viewPath}/Card`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}